/**
 * @author: Pankaj Kulshreshtha | Cheers Interactive
 * @date : 15/Mar/2021
 * File Description: Survey Form Action Button
 */

import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { getLoggedInUser, getProductVariant, accessRightActionCheck } from "../../../../utilities";
import { actionSuccess, actionError } from "../../../../middleware/actions/utilityAction";
import { useDispatch } from "react-redux";
import { showAlertBox } from "../../../../middleware/actions/alertBoxAction";
import { publishVideo } from "../../../../middleware/services/cmsApi";
import { updateTrends } from "../../../../middleware/services/videoApi";
import { PRODUCT_VARIANT, SUCCESS_TREND } from "constants";
import PropTypes from "prop-types";

const ActionButtons = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loggedInUser = getLoggedInUser();
  const productVariant = getProductVariant();
  const videoId = props.videoId || "";

  const [interfaceActionAccess, setInterfaceActionAccess] = useState([]);
  /* Interface action access from common access */
  useEffect(() => {
    let interfaceName = Object.values(props.hashArr)[props.selectedIndex];
    let actionAccess = accessRightActionCheck(props.moduleName, interfaceName);
    setInterfaceActionAccess(actionAccess);
  }, [props.selectedIndex]);

  let actionAccessSave = interfaceActionAccess.includes("Save");
  let actionAccessPublish = interfaceActionAccess.includes("Publish");

  const publish = async () => {
    const videoId = props.videoId;
    await publishVideo(videoId, { userId: loggedInUser._id, platform: productVariant })
      .then((res) => {
        if (res) {
          dispatch(actionSuccess("Video has been published successfully."));
        } else {
          dispatch(actionError("Something went wrong"));
        }
      })
      .catch((err) => {
        // let errMessage = "Video cannot published : <br>";
        // const errMessageArr = err?.data?.message ? err.data.message.split(",") : ["Something went wrong"];
        // errMessage += errMessageArr
        //   .map((value, index) => {
        //     return ++index + "." + value + "<br>";
        //   })
        //   .join("");
        dispatch(actionError(err?.data?.message || "Something went wrong"));
      });
  };

  const udpateTempTrends = async () => {
    const videoId = props.videoId;
    await updateTrends(videoId)
      .then((res) => {
        if (res) {
          dispatch(actionSuccess(SUCCESS_TREND));
        } else {
          dispatch(actionError("Something went wrong"));
        }
      })
      .catch((err) => {
        dispatch(actionError(err?.data?.message || "Something went wrong"));
      });
  };

  return (
    <div className="form-submit-box">
      <div className="footer-layout">
        {props.selectedIndex > 0 || props.selectedIndex === undefined ? (
          <button
            type="button"
            className="btn btn-outline-dark cy-btn"
            onClick={() => {
              (props.selectedIndex === undefined && props.setCurrentTab(3)) ||
                (props.selectedIndex < 6 && props.setCurrentTab(props.selectedIndex - 1));
            }}
          >
            Previous
          </button>
        ) : null}

        {videoId !== "" && props.selectedIndex > -1 && props.selectedIndex < 5 ? (
          <button
            type="button"
            className="btn btn-outline-dark cy-btn"
            onClick={() => {
              props.selectedIndex < 5 && props.setCurrentTab(props.selectedIndex + 1);
            }}
          >
            Next
          </button>
        ) : null}
      </div>
      <div className="footer-layout">
        <Link to={"/video"}>
          <button type="button" className="btn btn-outline-dark cy-btn">
            Cancel
          </button>
        </Link>

        {actionAccessSave && props.handleSave && props.selectedIndex != 4 && props.selectedIndex != 5 ? (
          <button type="button" className="btn btn-primary cy-btn" id="dev-objective-save" onClick={props.handleSave}>
            Save
          </button>
        ) : null}

        {props.selectedIndex == 4 && productVariant === PRODUCT_VARIANT.INSIDER ? (
          <button
            type="button"
            className="btn btn-primary cy-btn"
            id="dev-objective-save"
            onClick={() => {
              udpateTempTrends();
              props.setSaveTrendTreeData(true);
            }}
          >
            Save
          </button>
        ) : null}

        {actionAccessPublish && props.showPublished ? (
          <button
            type="button"
            className="btn btn-primary cy-btn"
            onClick={() => {
              dispatch(
                showAlertBox({
                  okCallback: async () => {
                    await publish();
                  },
                  okText: "Publish",
                  cancelText: "Cancel",
                  content: "Are you sure you want to publish video?",
                  title: "dialogAlertCss",
                })
              );
            }}
          >
            Publish
          </button>
        ) : null}
      </div>
    </div>
  );
};

ActionButtons.propTypes = {
  videoId: PropTypes.string,
  selectedIndex: PropTypes.number,
  setCurrentTab: PropTypes.number,
  handleSave: PropTypes.func,
  showPublished: PropTypes.func,
  hashArr: PropTypes.object,
  moduleName: PropTypes.string,
  setSaveTrendTreeData: PropTypes.func,
};

export default ActionButtons;
